/**
 * Create React App entry point. This and `public/index.html` files can not be
 * changed or moved.
 */
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
// import axiosInstance from "./app/myAxiosInstance";
import store, { persistor } from "./app/store/store";
import App from "./App";
import "./index.scss"; // Standard version
import "socicon/css/socicon.css";
import "./_metronic/_assets/plugins/line-awesome/css/line-awesome.css";
import "./_metronic/_assets/plugins/flaticon/flaticon.css";
import "./_metronic/_assets/plugins/flaticon2/flaticon.css";
import 'react-notifications-component/dist/theme.css';
import "react-datepicker/dist/react-datepicker.css";
import firebaseConfig from './firebase.config';
import * as firebase from "firebase/app";
import "firebase/analytics";

const firebaseApp = firebase.initializeApp(firebaseConfig);
firebase.analytics(firebaseApp);  

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { PUBLIC_URL } = process.env;

/**
 * Inject metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */


ReactDOM.render(
    <App
    store={store}
    persistor={persistor}
    basename={PUBLIC_URL}
    />,
  document.getElementById("root")
);
